import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getEmployee } from "../../actions/employeeActions";
import ViewForm from "./ViewForm";
import { Grid, TextField, Avatar } from "@material-ui/core";
import moment from "moment";

class EmployeeViewForm extends Component {
  state = {
    firstName: "",
    lastName: "",
    bsnNumber: "",
    birthday: "",
    facePhoto: "",
    email: "",
    phone: "",
    street: "",
    streetNumber: "",
    zipcode: "",
    city: "",
    emergencyPerson: "",
    emergencyPhone: "",
    clothingPoloSize: "",
    clothingCombatJeansSize: "",
    clothingGiletSize: "",
    clothingShirtSize: "",
    clothingBlouseSize: "",
    clothingPantSize: "",
    clothingShoeSize: "",
  };

  componentDidMount() {
    this.setState({ email: this.props.email });

    this.props.getEmployee(this.props.email).then((response) => {
      let facePhoto = new Buffer(response.facePhoto, "base64").toString(
        "binary",
      );

      this.setState({ ...response, facePhoto: facePhoto });
    });
  }

  onSubmit = () => {
    this.props.onSuccess();
  };

  render() {
    return (
      <ViewForm
        onSubmit={this.props.onSuccess ? this.onSubmit : null}
        submitText="OK"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={3} sm={3}>
            <Avatar
              alt="Remy Sharp"
              src={this.state.facePhoto}
              style={{ width: "100px", height: "100px", margin: "0 auto" }}
            />
          </Grid>

          <Grid item xs={9} sm={9}>
            <Grid item xs={12} sm={12}>
              <TextField
                id="name"
                name="name"
                label="Naam *"
                value={`${this.state.firstName} ${this.state.lastName}`}
                onChange={this.handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                id="email"
                name="email"
                label="E-mailadres *"
                value={this.state.email}
                onChange={this.handleChange}
                disabled={true}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                id="phone"
                name="phone"
                label="Telefoonnummer *"
                value={this.state.phone}
                onChange={this.handleChange}
                fullWidth
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              id="bsnNumber"
              name="bsnNumber"
              label="BSN-nummer *"
              value={this.state.bsnNumber}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              id="birthday"
              name="birthday"
              label="Geboortedatum *"
              value={moment(this.state.birthday).format("dddd, LL")}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={9}>
            <TextField
              id="street"
              name="street"
              label="Adres *"
              value={this.state.street}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              id="streetNumber"
              name="streetNumber"
              label="Huisnr. *"
              value={this.state.streetNumber}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="zipcode"
              name="zipcode"
              label="Postcode *"
              value={this.state.zipcode}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="city"
              name="city"
              label="Plaats *"
              value={this.state.city}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="emergencyPerson"
              name="emergencyPerson"
              label="Persoon voor noodgeval *"
              value={this.state.emergencyPerson}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="emergencyPhone"
              name="emergencyPhone"
              label="Telefoonnummer voor noodgeval *"
              value={this.state.emergencyPhone}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            Kledingmaten
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingBlouseSize"
              name="clothingBlouseSize"
              label="Bloes *"
              value={this.state.clothingBlouseSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingGiletSize"
              name="clothingGiletSize"
              label="Gilet *"
              value={this.state.clothingGiletSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingShirtSize"
              name="clothingShirtSize"
              label="Overhemd *"
              value={this.state.clothingShirtSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingPoloSize"
              name="clothingPoloSize"
              label="Polo *"
              value={this.state.clothingPoloSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingCombatJeansSize"
              name="clothingCombatJeansSize"
              label="Combatbroek *"
              value={this.state.clothingCombatJeansSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingPantSize"
              name="clothingPantSize"
              label="Pantalon *"
              value={this.state.clothingPantSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              id="clothingShoeSize"
              name="clothingShoeSize"
              label="Schoenen *"
              value={this.state.clothingShoeSize}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </ViewForm>
    );
  }
}

EmployeeViewForm.propTypes = {
  getEmployee: PropTypes.func.isRequired,
  email: PropTypes.string,
  onSuccess: PropTypes.func,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.employee.getEmployee.successMessage,
  errorMessage: state.employee.getEmployee.errorMessage,
  isFetching: state.employee.getEmployee.isFetching,
});

export default connect(mapStateToProps, { getEmployee })(EmployeeViewForm);



// WEBPACK FOOTER //
// ./src/components/forms/EmployeeViewForm.js